import { Check } from "lucide-react";

import { cn } from "@/shared/lib/cn";
import {
  ONBOARDING_STEPS,
  STEP_LABELS,
  type OnboardingStep,
} from "@/features/onboarding/types";

interface Props {
  current: OnboardingStep;
}

export function StepIndicator({ current }: Props) {
  const currentIndex = ONBOARDING_STEPS.indexOf(current);
  return (
    <ol className="flex items-center">
      {ONBOARDING_STEPS.map((step, idx) => {
        const isDone = idx < currentIndex;
        const isCurrent = idx === currentIndex;
        const isLast = idx === ONBOARDING_STEPS.length - 1;
        return (
          <li
            key={step}
            className={cn("flex items-center gap-2", !isLast && "flex-1")}
          >
            <span
              className={cn(
                "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-xs font-semibold leading-none tabular-nums transition-colors",
                isDone && "border-primary bg-primary text-primary-foreground",
                isCurrent && "border-primary bg-primary-light text-primary",
                !isDone && !isCurrent && "border-border bg-surface text-copy-subtle",
              )}
              aria-current={isCurrent ? "step" : undefined}
            >
              {isDone ? <Check className="h-3 w-3" /> : idx + 1}
            </span>
            <span
              className={cn(
                "hidden whitespace-nowrap text-xs lg:inline",
                isCurrent ? "font-semibold text-copy" : "text-copy-muted",
              )}
            >
              {STEP_LABELS[step]}
            </span>
            {!isLast && (
              <span
                className={cn(
                  "h-px flex-1 min-w-4",
                  isDone ? "bg-primary" : "bg-border",
                )}
                aria-hidden
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
